import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../app/providers/AuthProvider";
import LoadingSpinner from "../../../shared/ui/LoadingSpinner";
import { canAccessPermission } from "../../../shared/permissions";
import RouteFallback from "./RouteFallback";

/**
 * Gate a route/page by job permission key(s) only.
 *
 * Navigation (job_details.sidemenu) must NOT grant route access.
 * Use canAccessPermission / useAuth().can — includes permissions: ["all"].
 */
export default function RequirePermission({
  permission,
  children,
  fallback = "/",
}) {
  const { loading, isAuthenticated, profile, can } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!permission) {
    return <RouteFallback fallback={fallback} />;
  }

  const job = profile?.job_details;
  const allowed =
    typeof can === "function"
      ? can(permission)
      : canAccessPermission(job, permission);

  if (allowed) {
    return children;
  }

  return <RouteFallback fallback={fallback} />;
}
